<ui-toolbar-top [title]="msg.nav.user_notes" [state]="scrollState()" [backVisible]="true"></ui-toolbar-top>

<ui-user-notes #content cdkScrollable></ui-user-notes>